import { useTranslation } from "react-i18next";
import { AddToDataDepot } from "./AddToDataDepot"
import { WorkflowSession } from "./WorkflowSession"
import DefaultCheckbox from "./DefaultCheckbox"
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useContext, useState } from "react";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep, debounce, isEqual, } from "lodash";
import { treeActions } from "../../../../redux/slices/treeSlice";

export const ProcessingOptionsSection = ({updatedSelectedNode, setUpdatedSelectedNode}) => {
  //util
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //redux
  const parentScreen = useContext(ParentScreenCtx);
  // const queryParams = useSelector((state) => state.queryParams);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const templateHeader = rightTree.tree.templateHeader;

  const [reportTruncationErrors, setReportTruncationErrors] = useState(selectedNode.RPT_TRUNC_ERR && selectedNode.RPT_TRUNC_ERR === "FALSE" ? false : true); 


  const modifyUpdatedNode = (prop, val) => {
    //RPT_TRUNC_ERR is a weird case, it operates backwards in the backend.
    if (val) {
      setUpdatedSelectedNode(prev => {
        return {...prev, [prop]: null}
      });
    } else {
      setUpdatedSelectedNode(prev => {
        return {...prev, [prop]: "FALSE"}
      });
    }
  }

  // clone tdata, loop thru and find curr node, 
  // set property to new val, then dispatch new tdata.
  // const storeInputVal = (prop, newVal, tData, sNode) => {
  //   let newSelectedNode = cloneDeep(sNode);
  //   let updatedData = eachDeep(cloneDeep(tData), (value, key, parentArr, ctx) => {
  //     if (typeof value !== 'object') return;
  //     if (value?.nodeId && value.nodeId === sNode.nodeId) {
  //       //if this node is selnode, set new property val.
  //       //special case for RPT_TRUNC_ERR, operates backwards in backend.
  //       if (newVal === false) {
  //         value[prop] = "FALSE";
  //         newSelectedNode[prop] = "FALSE";
  //       } else {
  //         delete value[prop];
  //         delete newSelectedNode[prop];
  //       }
  //     }
  //   });

  //   //prevent dispatch for no reason
  //   if (isEqual(tData, updatedData)) return;
    
  //   //set new trans data to updatedData.
  //   dispatch(
  //     treeActions.setNewRightTreeTranslatedData({
  //       screen: parentScreen,
  //       type: rightTree.currentTab,
  //       data: updatedData,
  //     })
  //   );

  //   //set selectedNode to match.
  //   dispatch(
  //     treeActions.setRightTreeSelectedNode({
  //       screen: parentScreen,
  //       type: rightTree.currentTab,
  //       data: newSelectedNode,
  //     })
  //   );
  // }

  // const debouncedSave = useCallback(
  //   debounce((prop, newVal, tData, sNode) => storeInputVal(prop, newVal, tData, sNode), 150, true), []
  // )

  const handleReportTruncationErrorsChange = (val) => {
    setReportTruncationErrors(val);
    modifyUpdatedNode("RPT_TRUNC_ERR", val);
  }

  return (
    <div style={{display: "flex", flexDirection: "column",}}>
      {/* Report Truncation Errors */}
      <DefaultCheckbox
        label={t("BTN_REPORT_TRUNCATION_ERRORS")}
        name={"BTN_REPORT_TRUNCATION_ERRORS"}
        value={reportTruncationErrors}
        setValue={handleReportTruncationErrorsChange}
      />

      {/* Add to Workflow Sessions */}
      <WorkflowSession updatedSelectedNode={updatedSelectedNode} setUpdatedSelectedNode={setUpdatedSelectedNode}/>

      {/* Add to Data Depot */}
      <AddToDataDepot updatedSelectedNode={updatedSelectedNode} setUpdatedSelectedNode={setUpdatedSelectedNode}/>
    </div>
  )
}

